import React from "react"
import { composeSx } from "../theme/composeSx"
import {
  Checkbox,
  FormControlLabel,
  type CheckboxProps,
  type FormControlLabelProps,
} from "@mui/material"
import { colors } from "../theme/tokens"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type ViraCheckboxProps = CheckboxProps & {
  label?: React.ReactNode
  labelProps?: Omit<FormControlLabelProps, "control" | "label">
}

/** Checkbox styled for Vira; safe outside `ViraThemeProvider`. */
export function ViraCheckbox({
  label,
  labelProps,
  disabled,
  sx,
  ...rest
}: ViraCheckboxProps) {
  const control = (
    <Checkbox
      disabled={disabled}
      sx={composeSx((theme) => {
        const vira = resolveViraPalette(theme)
        return {
          color: vira.softBorder,
          "&.Mui-checked": {
            color:
              theme.palette.mode === "dark"
                ? vira.lavenderText
                : colors.primary.shadow,
          },
        }
      }, sx)}
      {...rest}
    />
  )
  if (label == null) return control
  return (
    <FormControlLabel
      control={control}
      label={label}
      disabled={disabled}
      {...labelProps}
    />
  )
}
